import React from 'react';

import { Input, Divider, Button } from 'antd';
import FileUpload from '../FileUpload';

const { TextArea } = Input;

const FormWithDescription = ({
  row,
  action,
  removeAction,
  parentKey,
  id,
  index
}) => {
  let fileList = row ? (row.attachment ? row.attachment : []) : [];

  return (
    <div>
      <Divider orientation="left" orientationMargin={0}>
        #{index + 1}
      </Divider>

      <TextArea
        key={parentKey}
        placeholder="Describe"
        value={row?.details}
        onChange={(e) =>
          action({
            ...row,
            details: e.target.value
          })
        }
      />
      <br />
      <br />
      <FileUpload
        fileList={fileList}
        row={row}
        action={action}
        parentKey={parentKey}
      />

      <Divider orientation="right" orientationMargin={0}>
        <Button onClick={() => removeAction(id)} danger>
          Remove
        </Button>
      </Divider>
    </div>
  );
};

export default FormWithDescription;
